import { render, staticRenderFns } from "./redirect.vue?vue&type=template&id=20065f44&scoped=true&"
import script from "./redirect.vue?vue&type=script&lang=js&"
export * from "./redirect.vue?vue&type=script&lang=js&"
import style0 from "./redirect.vue?vue&type=style&index=0&id=20065f44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20065f44",
  null
  
)

export default component.exports